import React, { useState, useEffect } from "react";
import { maskAccountDetail } from "../../utils/maskUtils";

function BankingDetail({ clientData, onDataChange }) {
  const [focusedField, setFocusedField] = useState(null);
  const [localValues, setLocalValues] = useState({
    bankHolderName: '',
    accountNumber: '',
    bankName: '',
    routingNumber: '',
    description: ''
  });

  useEffect(() => {
    if (clientData) {
      setLocalValues({
        bankHolderName: clientData.BankHolderName || clientData.bankHolderName || '',
        accountNumber: clientData.AccountNumber || clientData.accountNumber || '',
        bankName: clientData.BankName || clientData.bankName || '',
        routingNumber: clientData.RoutingNumber || clientData.routingNumber || '',
        description: clientData.Description || clientData.description || ''
      });
    }
  }, [clientData]);

  const handleChange = (field, value) => {
    const newLocalValues = {
      ...localValues,
      [field]: value
    };
    setLocalValues(newLocalValues);

    if (onDataChange) {
      const result = {
        BankHolderName: newLocalValues.bankHolderName,
        BankName: newLocalValues.bankName,
        AccountNumber: newLocalValues.accountNumber,
        RoutingNumber: newLocalValues.routingNumber,
        Description: newLocalValues.description,
        bankHolderName: newLocalValues.bankHolderName,
        accountNumber: newLocalValues.accountNumber,
        bankName: newLocalValues.bankName,
        routingNumber: newLocalValues.routingNumber,
        description: newLocalValues.description
      };

      onDataChange(result);
    }
  };

  const getDisplayValue = (fieldName) => {
    if (focusedField === fieldName) {
      return localValues[fieldName] || '';
    }

    if (localValues[fieldName]) {
      return maskAccountDetail(localValues[fieldName]);
    }

    return '';
  };

  return (
    <div className="editpresoldetail mb_20">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="white_card">
              <div className="row">
                {/* TITLE */}
                <div className="col-md-2">
                  <h4 className="mt_20">Banking Details</h4>
                </div>

                {/* LEFT COLUMN */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    <div className="form_group">
                      <label>Holder Name</label>
                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Emma Williams"
                        value={getDisplayValue("bankHolderName")}
                        onChange={(e) =>
                          handleChange("bankHolderName", e.target.value)
                        }
                        //onFocus={() => setFocusedField("bankHolderName")}
                        onBlur={() => setFocusedField(null)}
                      />
                    </div>

                    <div className="form_group">
                      <label>Account Number</label>
                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="1234567890"
                        value={getDisplayValue("accountNumber")}
                        onChange={(e) =>
                          handleChange("accountNumber", e.target.value)
                        }
                        //onFocus={() => setFocusedField("accountNumber")}
                        onBlur={() => setFocusedField(null)}
                      />
                    </div>

                    <div className="form_group">
                      <label>Description</label>
                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Enter description (9-10 characters)"
                        value={getDisplayValue("description")}
                        onChange={(e) =>
                          handleChange("description", e.target.value)
                        }
                        //onFocus={() => setFocusedField("description")}
                        onBlur={() => setFocusedField(null)}
                        minLength={9}
                        maxLength={10}
                      />
                    </div>

                  </div>
                </div>

                {/* RIGHT COLUMN */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    <div className="form_group">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Chase Bank"
                        value={getDisplayValue("bankName")}
                        onChange={(e) =>
                          handleChange("bankName", e.target.value)
                        }
                        //onFocus={() => setFocusedField("bankName")}
                        onBlur={() => setFocusedField(null)}
                      />
                    </div>

                    <div className="form_group">
                      <label>Routing Number</label>
                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="1234567890"
                        value={getDisplayValue("routingNumber")}
                        onChange={(e) =>
                          handleChange("routingNumber", e.target.value)
                        }
                        //onFocus={() => setFocusedField("routingNumber")}
                        onBlur={() => setFocusedField(null)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* BUTTON ROW (same as old design) */}
              <div className="row">
                <div className="col-md-12">
                  <a href="#" className="btn_primary"></a>
                </div>
              </div>
              {/* END BUTTON */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BankingDetail;
